import { AccountCashflow } from '../type';
import { computeCashflowAfterTaxAndComInAccountCurrency } from './cashflowPrice';
import { cashflowLineHasRefund } from './hasRefund';
import { computeRefundValueFromLineInAccountCurrency } from './refundPrice';

export const cashflowPriceWithRefundInAccountCurrency = (cashflowLines: AccountCashflow[] | undefined) => (cashflowLines ? cashflowLines.reduce((acc, line) => {
  const refundPrice = cashflowLineHasRefund(line) ? computeRefundValueFromLineInAccountCurrency(line) : 0;
  return acc + computeCashflowAfterTaxAndComInAccountCurrency(line) + refundPrice;
}, 0) : 0);
